<div style="height: 100%" #viewerContainer>
  <pinch-zoom *ngIf="isImage" style="height: 100%">
    <img [src]="this.localUrl" (load)="hideLoader = true" />
  </pinch-zoom>
  <video preload="metadata" style="height: 100%" *ngIf="isVideo" controls>
    <source [src]="getFileVideoSource()" type="video/mp4" />
  </video>
</div>
